import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AuthEmailOtpRequestBody, AuthEmailOtpResponse } from "./types";

export class AuthEmailOtpAPI extends BaseAPI<
  AuthEmailOtpRequestBody,
  AuthEmailOtpResponse
> {
  protected route = ApiRoutes.auth.send_email_otp;
  protected method = RequestMethod.POST;
}

